import React, {
  useState,
  useEffect,
  useRef,
  lazy,
  Suspense,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import SplAlert from "../../components/ResturantMessageBar/splAlert.js";
// Material
import Fade from "@material-ui/core/Fade";
// Components
// import CategoryItem from "./../../components/CategoryItem/CategoryItem";
// import Modal from "./../../components/Material/Modal/Modal";
// import ViewProduct from "./../../components/ViewProduct/ViewProduct";
// Component Loader
import CategoryItemLoader from "./../../components/CategoryItem/CategoryItem.loader";
// import ComboItem from "../../components/ComboItem/ComboItem";
// import ViewCombo from "../../components/ViewComboProd/ViewCombo.js";
// import IdleTracker from "idle-tracker";
// Style
import useStyles from "./Home.style.js";
//analytics
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import {
  clearTable,
  getTableDetails,
  setIsProfileSecondPage,
  setIsTodayHoliday,
  setTableId,
} from "../../store/Restaurant/RestaurantActions";
import useSearchHook from "../../CustomHooks/useSearchHook";
import { Dialog, Grid, Typography } from "@material-ui/core";
// import ChoiceItem from "../../components/ChoiceItem/ChoiceItem";
import {
  getCartSuggestions,
  getMenuCategoryList,
  setActiveCategory,
  toggleCategoryHomeMenu,
} from "../../store/Menu/MenuActions";
import clsx from "clsx";
//Image
import * as noImage from "./../../assets/images/noImage.png";
import {
  dispatchErrorMessageAsWarning,
  dispatchResetErrorMessage,
} from "../../utils/Shared";
import {
  clearLocation,
  getUserCountryRequest,
  getValidLocationRequest,
} from "../../store/Location/LocationActions";
import { updateNumberPrefix } from "../../config/app-config";
// import SpecialAlert from "../../components/SpecialAlert/SpecialAlert";
import { useLocation } from "react-router-dom";
import useCheckoutForm from "../../CustomHooks/useCheckoutForm";
import { ORDER_TYPES } from "../../utils/Constants";
import {
  clearCart,
  clearCoupon,
  setCouponValidationResult,
} from "../../store/Cart/CartActions";
import { cloneDeep } from "lodash";
import { useHistory } from "react-router-dom";
import moment from "moment";
import HolidayModal from "../../components/SpecialAlert/HolidayModal.js";
import {
  resetWallet,
  setDirectLogin,
  setUsedWalletPoint,
} from "../../store/Profile/ProfileActions.js";
import useWalletPoints from "../../CustomHooks/useWalletPoints.js";
import LoginDialogCon from "../../components/Checkout/LoginDetailsForm/LoginDetailsForm.js";
import { setFlavour } from "../../store/App/AppActions.js";
import BasicLoader from "../../components/Loader/BasicLoader.js";
import Navbar from "../../components/Navbar/Navbar.js";
import usePriceSummary from "../../CustomHooks/usePriceSummary.js";
import useSortHook from "../../CustomHooks/useSortHook.js";
import useDynamicHotelData from "../../CustomHooks/useDynamicHotelData.js";
import { generateDateSlots } from "../../utils/utils.js";
import { isTodayBirthday } from "../../CustomHooks/useThemeHook.js";
import BirthdayCard from "../../components/BirthdayCard/BirthdayCard.js";
import LazyLoadComponent from "../../components/VirtualizedCategoryList/VirtualizedCategoryList.js";
import InfiniteScrollComponent from "../../components/VirtualizedCategoryList/VirtualizedCategoryList.js";
import useIsBottom from "../../components/VirtualizedCategoryList/useIsBottom.js";
import { useCallback } from "react";

const CategoryItem = lazy(() =>
  import("./../../components/CategoryItem/CategoryItem")
);
const Modal = lazy(() => import("./../../components/Material/Modal/Modal"));
const ViewProduct = lazy(() =>
  import("./../../components/ViewProduct/ViewProduct")
);
// const CategoryItemLoader = lazy(() =>
//   import("./../../components/CategoryItem/CategoryItem.loader")
// );
const ComboItem = lazy(() => import("../../components/ComboItem/ComboItem"));
const ViewCombo = lazy(() =>
  import("../../components/ViewComboProd/ViewCombo.js")
);
const SpecialAlert = lazy(() =>
  import("../../components/SpecialAlert/SpecialAlert")
);
const CardMedia = lazy(() => import("@material-ui/core/CardMedia"));
// const HolidayModal = lazy(() =>
//   import("../../components/SpecialAlert/HolidayModal.js")
// );

const Home = (props) => {
  useSearchHook();
  const classes = useStyles();
  const sectionsRefs = useRef([]);
  const dispatch = useDispatch();
  const modalInit = {
    type: "",
    show: false,
  };
  const { validAddress } = useSelector((state) => state.location);
  const userCountryCode = useSelector(
    (state) => state.location.userCountryCode
  );
  const state = useSelector((state) => state.menu);
  const {
    hotel,
    tableId,
    hotelKey,
    isHotelFetchCompleted,
    isTodayHoliday,
    todayHolidayLabel,
    isBirthDay,
    userData,
  } = useSelector((state) => state.hotel);
  const {
    isScrolled,
    sortedCategoryMenu,
    sortedComboMenu,
    combo,
    menuVersion,
  } = useSelector((state) => state.menu);
  const user = useSelector((state) => state.user);
  const { data, checkoutDetails, selectedCoupon } = useSelector(
    (state) => state.cart
  );
  const [holidayModal, setHolidayModal] = useState(false);
  //
  const parentDomRef = useRef(null);
  const scrollRef = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedLoginAttempt = queryParams.get("login");
  const { hash } = location;
  const idFromLink = hash.substring(1);
  const { formValues, setFormValues } = useCheckoutForm();
  const [filteredProds, setFilteredProds] = useState([]);
  const [loginOpen, setLoginOpen] = useState(false);
  const priceSummary = usePriceSummary();
  const [birthdayModal, setBirthdayModal] = useState(false);
  const [showPopper, setShowPopper] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const isBottom = useIsBottom();
  const {
    checkProductAvailability,
    checkComboCatAvailability,
    formatDateToCheck,
  } = useSortHook();
  const history = useHistory();
  const { isDirectLogin } = useSelector((state) => state.profile);
  const [currentTime, setCurrentTime] = useState(moment()); // Initialize current time using moment
  // Update current time every second using useEffect
  const [nextAvailableTime, setNextAvailableTime] = useState("");
  // console.log("checkoutDetails", checkoutDetails);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);
  // useEffect(() => {
  //   if (user?.address) {
  //     dispatch(getValidLocationRequest(user?.address));
  //   }
  // }, [dispatch, user]);
  useEffect(() => {
    if (user && isDirectLogin) {
      history.push(`/${hotelKey}/profile`);
      dispatch(setDirectLogin(false));
    }
  }, [dispatch, user, isDirectLogin]);

  // useEffect(() => {
  //   if (userData && userData?.birthday) {
  //     if (isTodayBirthday(userData?.birthday)) {
  //       // console.log("workingggg 111111111");
  //       setBirthdayModal(true);
  //     } else {
  //       // console.log("workingggg 22222222");

  //       setBirthdayModal(false);
  //     }
  //   }
  // }, [userData]);
  // const bdy = "2018-11-27";

  // useEffect(() => {
  //   if (bdy) {
  //     if (isTodayBirthday(bdy)) {
  //       setShowPopper(true); // Start popper
  //     const timer = setTimeout(() => {
  //       setShowPopper(false); // Stop popper after 3 seconds
  //     }, 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [bdy]);
  useEffect(() => {
    if (userData && userData?.birthday) {
      if (isTodayBirthday(userData?.birthday)) {
        setBirthdayModal(true); // Start popper
        setShowPopper(true);
        const timer = setTimeout(() => {
          setBirthdayModal(false);
          setShowPopper(false); // Stop popper after 3 seconds
        }, 5000);
        return () => clearTimeout(timer); // Cleanup timeout
      }
    }
  }, [userData]);

  useEffect(() => {
    if (idFromLink) {
      dispatch(getMenuCategoryList(idFromLink));
    }
  }, [idFromLink]);

  useEffect(() => {
    const loginAttempt = encodedLoginAttempt
      ? decodeURIComponent(encodedLoginAttempt)
      : null;

    if (loginAttempt === "true") {
      // Display your login popup here
      setLoginOpen(true);
    }
  }, [encodedLoginAttempt]);

  const [modal, toggleModal] = useState(modalInit);
  const [product, selectProduct] = useState({
    info: null,
    addons: null,
    categoryId: null,
    menuVersion: null,
  });
  const [comboo, selectCombo] = useState({
    info: null,
    addons: null,
    comboId: null,
  });
  const [isOnIdle, setIsOnIdle] = useState(false);
  const [showLandingPage, setShowLandingPage] = useState();
  const [specialModal, setSpecialModal] = useState(false);
  const [productCopy, setProductCopy] = useState({});
  const [cartClearModal, setCartClearModal] = useState(false);
  const {
    walletPointsFromType2,
    RemoveItemCoupon,
    getWalletRedemption,
    resetWalletProducts,
  } = useWalletPoints();
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [orderTimeType, setOrderTimeType] = useState("SCHEDULED");
  const [dateSlots, setDateSlots] = useState([]);
  const {
    getOrderTypes,
    getDeliveryIntervalSlots,
    getTodayDeliveryIntervalSlots,
    isAsapAvailable,
    isMultipleOrderType,
    getAsapTime,
  } = useDynamicHotelData();

  useEffect(() => {
    if (isScrolled) {
      setFilteredProds(sortedCategoryMenu);
    } else {
      setFilteredProds(sortedCategoryMenu?.slice(0, 5));
    }
  }, [isScrolled, sortedCategoryMenu]);
  // console.log("filterrrrrrrrrrrrrrr", filteredProds);

  useEffect(() => {
    if (hotelKey) {
      dispatch(setCouponValidationResult(false));
      dispatch(getCartSuggestions(hotelKey));
      dispatch(setIsProfileSecondPage(false));
    }
  }, []);

  // set order time and date if order dialog is not open

  // set the initial ordertype
  const currentOrderType = useMemo(() => {
    return getOrderTypes?.length > 0 && getOrderTypes[0]?.type;
  }, [getOrderTypes]);

  // console.log("currentOrderType", currentOrderType);

  // set the initial delivery type
  const currentDeliveryType = useMemo(() => {
    return isAsapAvailable && hotel?.openingAvailable ? "ASAP" : "SCHEDULED";
  }, [isAsapAvailable, hotel?.openingAvailable]);

  // console.log("currentDeliveryType", currentDeliveryType);
  const firstDate = () => {
    const dateSlots = generateDateSlots(hotel, currentOrderType);
    return dateSlots[0]?.date;
  };

  const filterTimeSlots = (slots, type) => {
    // if (!slots || slots.length === 0) return null;

    if (type === "ASAP") {
      // Return the first slot with type "ASAP"
      return slots?.find((sl) => sl?.typeOfOrder === "ASAP") || null;
    } else {
      // Return the first slot with type "SCHEDULED"
      return slots?.find((sl) => sl?.typeOfOrder === "SCHEDULED") || null;
    }
  };

  const firstTime = () => {
    const timeSlots =
      getTodayDeliveryIntervalSlots?.length > 0
        ? getTodayDeliveryIntervalSlots
        : getDeliveryIntervalSlots;
    const filteredTime = filterTimeSlots(timeSlots, currentDeliveryType);
    return filteredTime;
  };

  const currentDate = useMemo(() => {
    return firstDate();
  });
  // console.log("currentDate", currentDate);

  const currentTimeslot = useMemo(() => {
    return firstTime();
  }, [dateSlots]);

  // console.log("currentTimeslot", currentTimeslot);

  const generateDatePickerSlots = () => {
    let orderTypeValue = currentOrderType;
    if (currentOrderType === ORDER_TYPES.TABLE_BOOKING_AND_ORDERING) {
      orderTypeValue = ORDER_TYPES.OPENING;
    }
    const dates = generateDateSlots(hotel, orderTypeValue) || [];
    setDateSlots(dates);
    if (dates) {
      onSelectOrderType("deliveryTime", currentDate);
    }
    if (!dates || !dates?.length) {
      // setDateSlotsError(true);
    }
  };

  useEffect(() => {
    if (
      (hotel || formValues?.orderType || currentOrderType) &&
      hotel?.order_prompt_dialog
    ) {
      generateDatePickerSlots();
    }
  }, [
    hotel,
    formValues?.orderType,
    currentOrderType,
    hotel?.order_prompt_dialog,
  ]);

  const onSelectOrderType = (fieldName, val) => {
    if (fieldName === "orderType") {
      // setFormValues({ [fieldName]: val });
      localStorage.setItem("orderType", val);
      setFormValues({
        ...formValues,
        orderType: val,
        customer_address: null,
        customer_city: null,
        customer_zipcode: null,
      });
      dispatch(clearLocation());
      if (selectedCoupon?.id) {
        RemoveItemCoupon(selectedCoupon);
      }
      dispatch(clearCoupon());
    }

    // setOpenOrderTypeModal(false);
    dispatch(resetWallet());
    resetWalletProducts(2);
    // dispatch(setOrderTypeModal(false));
    setFormValues({ [fieldName]: val });
  };

  const onDateAndTimeSelect = (deliveryType, deliveryTime) => {
    onSelectOrderType("deliveryType", deliveryType);
    onSelectOrderType("deliveryTime", deliveryTime);
  };

  useEffect(() => {
    if (hotel?.order_prompt_dialog) {
      if (!checkoutDetails?.orderType) {
        onSelectOrderType("orderType", currentOrderType);
      }
      if (!checkoutDetails?.deliveryType) {
        onSelectOrderType("deliveryType ", currentDeliveryType);
      }
    }
  }, [hotel?.order_prompt_dialog]);

  useEffect(() => {
    if (dateSlots && hotel?.order_prompt_dialog) {
      const date = currentDate;

      // console.log("current time slottttttt", currentTimeslot);
      const time = currentTimeslot?.value;

      // const timeString = `${date}${time}`;
      // const dTime = moment(moment(timeString)).toISOString();
      const combinedDateTime = `${date} ${time}`;
      const dTime = moment(
        combinedDateTime,
        "MMMM D, YYYY hh:mm A"
      ).toISOString();
      onDateAndTimeSelect(currentDeliveryType || "SCHEDULED", dTime);
      // console.log("dateeeeeeeeeeeeee", date);
    }
  }, [dateSlots, hotel?.order_prompt_dialog]);

  useEffect(() => {
    // Check if menu versions match

    if (
      data?.length > 0 &&
      data?.some((cartItem) => menuVersion !== cartItem.menuVersion)
    ) {
      // Proceed with the rest of the function
      const shouldClearCart = data?.some((cartItem) => {
        if (!cartItem?.combo_id) {
          const categoryFromStore = sortedCategoryMenu?.find(
            (storeCategory) => storeCategory.categoryId === cartItem.categoryId
          );

          if (categoryFromStore) {
            const correspondingItem = categoryFromStore.item.find(
              (storeItem) => storeItem.itemId === cartItem.itemId
            );

            if (correspondingItem) {
              if (cartItem.sale_price !== correspondingItem.sale_price) {
                return true; // Clear cart if sale prices are not equal
              }

              // Check if size is present in the cart item
              if (cartItem.size) {
                // Find the corresponding size in the API data
                const correspondingSize = correspondingItem.sizes?.find(
                  (size) => size.id == cartItem.size
                );

                const correspondingSizeFromCart = cartItem?.sizes?.find(
                  (size) => size.id == cartItem.size
                );

                // Check if size_amount is not equal
                if (
                  correspondingSize &&
                  correspondingSizeFromCart &&
                  correspondingSizeFromCart.size_amount !==
                    correspondingSize.size_amount
                ) {
                  return true; // Clear cart if size_amounts are not equal
                }
              }

              // Check if modifier prices are not equal in groups
              if (
                correspondingItem.group &&
                correspondingItem.group.length > 0
              ) {
                return correspondingItem.group.some((group) => {
                  return group.addOns.some((addOn) => {
                    const correspondingAddOn = cartItem?.modifiers?.find(
                      (cartModifier) => {
                        return (
                          cartModifier.groupId === group.groupId &&
                          cartModifier.addOnId === addOn.addOnId &&
                          cartModifier.price !== addOn.price
                        );
                      }
                    );
                    return correspondingAddOn !== undefined;
                  });
                });
              }

              // Check if modifier prices are not equal in groupstoproduct
              if (
                correspondingItem.groups &&
                correspondingItem.groups.length > 0
              ) {
                return correspondingItem.groups.some((groupToProduct) => {
                  return groupToProduct.addOns.some((addOn) => {
                    const correspondingAddOn = cartItem.modifiers.find(
                      (cartModifier) => {
                        return (
                          cartModifier.groupId === groupToProduct.groupId &&
                          cartModifier.addOnId === addOn.addOnId &&
                          cartModifier.price !== addOn.price
                        );
                      }
                    );
                    return correspondingAddOn !== undefined;
                  });
                });
              }
              if (
                correspondingItem.groupstoproduct &&
                correspondingItem.groupstoproduct.length > 0
              ) {
                return correspondingItem.groupstoproduct.some(
                  (groupToProduct) => {
                    return groupToProduct.addOns.some((addOn) => {
                      const correspondingAddOn = cartItem.modifiers.find(
                        (cartModifier) => {
                          return (
                            cartModifier.groupId === groupToProduct.groupId &&
                            cartModifier.addOnId === addOn.addOnId &&
                            cartModifier.price !== addOn.price
                          );
                        }
                      );
                      return correspondingAddOn !== undefined;
                    });
                  }
                );
              }
            }
          }
        } else {
          if (Object.keys(sortedComboMenu).length > 0) {
            return Object.keys(sortedComboMenu).some((comboId) => {
              const combosFromStore = sortedComboMenu[comboId];
              if (combosFromStore) {
                // Find the corresponding combo based on combo_id
                const correspondingCombo = combosFromStore?.find(
                  (combo) => combo.combo_id === cartItem.combo_id
                );

                if (correspondingCombo) {
                  // Check if combo_price is not equal
                  if (cartItem.combo_price !== correspondingCombo.combo_price) {
                    return true; // Clear cart if combo prices are not equal
                  }
                }
                const productsFromStore =
                  correspondingCombo?.cat_mappings.flatMap(
                    (category) => category.products
                  );

                // Map cartItem?.combos?.individualProducts
                const individualProductsFromCart =
                  cartItem?.combos?.individualProducts;

                // Check if sale_price is not equal for individual products
                const isSalePriceNotEqual = individualProductsFromCart?.some(
                  (individualProduct) => {
                    const correspondingProduct = productsFromStore?.find(
                      (product) => product?.itemId === individualProduct?.itemId
                    );

                    return (
                      correspondingProduct &&
                      (individualProduct.sale_price !==
                        correspondingProduct.sale_price ||
                        individualProduct?.extra_price !==
                          correspondingProduct?.extra_price)
                    );
                  }
                );
                // Check if modifier prices are not equal
                const isModifierPriceNotEqual =
                  individualProductsFromCart?.some((individualProduct) => {
                    const correspondingProduct = productsFromStore?.find(
                      (product) => product?.itemId === individualProduct?.itemId
                    );

                    // Check if modifier prices are not equal in individualProduct
                    return correspondingProduct?.group.some((group) =>
                      group.addOns.some((addOn) => {
                        const correspondingAddOn =
                          individualProduct?.modifiers?.find(
                            (productModifier) =>
                              productModifier.addOnId === addOn.addOnId &&
                              productModifier.price !== addOn.price
                          );
                        return correspondingAddOn !== undefined;
                      })
                    );
                  });

                // Check if modifier prices are not equal in groupstoproduct
                const isGroupToProductModifierPriceNotEqual =
                  individualProductsFromCart?.some((individualProduct) => {
                    const correspondingProduct = productsFromStore?.find(
                      (product) => product?.itemId === individualProduct?.itemId
                    );

                    // Check if modifier prices are not equal in groupstoproduct
                    return correspondingProduct?.groupstoproduct?.some(
                      (groupToProduct) =>
                        groupToProduct.addOns.some((addOn) => {
                          const correspondingAddOn =
                            individualProduct?.modifiers?.find(
                              (productModifier) =>
                                productModifier.addOnId === addOn.addOnId &&
                                productModifier.price !== addOn.price
                            );
                          return correspondingAddOn !== undefined;
                        })
                    );
                  });

                const isGroupsModifierPriceNotEqual =
                  individualProductsFromCart?.some((individualProduct) => {
                    const correspondingProduct = productsFromStore?.find(
                      (product) => product?.itemId === individualProduct?.itemId
                    );

                    // Check if modifier prices are not equal in groupstoproduct
                    return correspondingProduct?.groups?.some(
                      (groupToProduct) =>
                        groupToProduct.addOns.some((addOn) => {
                          const correspondingAddOn =
                            individualProduct?.modifiers?.find(
                              (productModifier) =>
                                productModifier.addOnId === addOn.addOnId &&
                                productModifier.price !== addOn.price
                            );
                          return correspondingAddOn !== undefined;
                        })
                    );
                  });

                return (
                  isSalePriceNotEqual ||
                  isModifierPriceNotEqual ||
                  isGroupToProductModifierPriceNotEqual ||
                  isGroupsModifierPriceNotEqual
                );
              }
              return false;
            });
          }
        }

        return false;
      });

      // Clear the cart if needed
      if (shouldClearCart) {
        setCartClearModal(true);
      }
    }
  }, [data, sortedCategoryMenu, menuVersion, dispatch]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "-110px 0px -75% 0px",
      threshold: [0],
    };

    const observer = new IntersectionObserver((entries) => {
      // Find the entry with the highest intersection ratio
      let mostVisibleEntry = null;

      entries.forEach((entry) => {
        // console.log(
        //   `Entry: ${entry.target.dataset.id}, isIntersecting: ${entry.isIntersecting}, intersectionRatio: ${entry.intersectionRatio}`
        // );
        if (
          entry.isIntersecting &&
          (!mostVisibleEntry ||
            entry.intersectionRatio > mostVisibleEntry.intersectionRatio)
        ) {
          mostVisibleEntry = entry;
        }
      });
      if (mostVisibleEntry) {
        const activeCategoryId = mostVisibleEntry.target.dataset.id;

        dispatch(setActiveCategory(activeCategoryId));
      }
    }, options);

    sectionsRefs.current.forEach((ref) => {
      if (ref) {
        // console.log("Observing:", ref);
        observer.observe(ref);
      }
    });

    return () => {
      sectionsRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [dispatch, filteredProds]);

  // useEffect(() => {
  //   console.log("workinggggggggg use............");
  //   const handleScroll = () => {
  //     console.log("workinggggggggg 111111111111");
  //     const scrollPosition = window.scrollY + 150; // Adjusted scroll position
  //     const elements = document.querySelectorAll(".category-item");

  //     let topCategory = null;

  //     // Iterate through the elements to find the one at the desired position
  //     elements.forEach((element) => {
  //       const rect = element.getBoundingClientRect();
  //       const elementTop = rect.top + window.scrollY;

  //       if (elementTop <= scrollPosition) {
  //         topCategory = element.textContent;
  //       }
  //       console.log("topCatgeeeeeeeeeeeeeee", topCategory);
  //       dispatch(setActiveCategory(topCategory));
  //     });
  //   };

  //   const scrollElement = parentDomRef.current;
  //   console.log("scrollElementttttttt", scrollElement);
  //   if (scrollElement) {
  //     console.log("work..+++++++++++++");
  //     scrollElement.addEventListener("scroll", handleScroll);
  //   }

  //   return () => {
  //     if (scrollElement) {
  //       scrollElement.removeEventListener("scroll", handleScroll);
  //     }
  //   };
  // }, [dispatch, window]);

  useEffect(() => {
    if (user && data && getWalletRedemption()) {
      dispatch(setUsedWalletPoint(walletPointsFromType2()));
    } else {
      dispatch(resetWallet());
      resetWalletProducts(2);
    }
  }, [user, dispatch, data]);

  useEffect(() => {
    async function getLocation() {
      dispatch(getUserCountryRequest());
    }
    getLocation();
    // if (userCountryCode?.data) {
    //   updateNumberPrefix(userCountryCode?.data);
    // }
  }, [dispatch, userCountryCode?.data]);

  useEffect(() => {
    setShowLandingPage(state.showCategoryHomeMenu);
  }, [state.showCategoryHomeMenu]);
  // console.log("carttttttttttt", checkoutDetails);

  let nextAvailableSlot;

  const showNextAvailableTimePopup = () => {
    // Combine today's and future delivery slots
    const allSlots = [
      ...getTodayDeliveryIntervalSlots,
      ...getDeliveryIntervalSlots,
    ].filter((slot) => slot.typeOfOrder === "SCHEDULED"); // Consider only "SCHEDULED" slots
    // console.log("allSlots", allSlots);
    // Sort slots by time to find the earliest
    // const sortedSlots = allSlots?.sort((a, b) =>
    //   moment(a.value).isBefore(b.value) ? -1 : 1
    // );

    // Get the next available slot
    nextAvailableSlot = allSlots[0]?.label; // Assuming 'label' has human-readable time info
    setNextAvailableTime(allSlots[0]?.label);
    // console.log("allSlots 1111111111", allSlots[0]?.label);
    if (!nextAvailableSlot) {
      console.warn("No available slots found.");
      return;
    }
  };

  // Example trigger
  useEffect(() => {
    if (!hotel?.openingAvailable) {
      showNextAvailableTimePopup();
    }
  }, [
    hotel?.openingAvailable,
    getTodayDeliveryIntervalSlots,
    getDeliveryIntervalSlots,
  ]);

  useEffect(() => {
    let timeoutId;

    if (hotel) {
      if (hotel?.openingAvailable === false && hotel?.is_preorder === 0) {
        dispatchErrorMessageAsWarning({
          title: "Alert",
          message:
            "We are currently closed. Kindly revisit during our designated opening hours.",
        });
      } else if (
        hotel?.openingAvailable === false &&
        hotel?.is_preorder === 1
      ) {
        dispatchErrorMessageAsWarning({
          title: "Warning",
          message: `You have arrived outside of our regular opening hours. However, you have the option to pre-order at ${nextAvailableTime}..`,
          noAutoClose: true,
        });
        timeoutId = null;
        // setAlertOpen(true);
      }
    }

    // Cleanup function
    if (timeoutId) {
      return () => {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          dispatchResetErrorMessage();
        }, 5000);
      };
    }
  }, [hotel, nextAvailableTime]);

  //if idle for 5mins => after user becomes active it reloads the page

  const onIdle = () => {
    setIsOnIdle(true);
  };
  const onActive = () => {
    if (isOnIdle) {
      setIsOnIdle(false);
      window.location.reload();
    }
  };

  // const idleTimer = useIdleTimer({ onIdle, onActive, timeout: 60000 });

  //idle timer code ends
  // console.log("checkoutDetails", checkoutDetails);

  React.useEffect(() => {
    try {
      const tableIdParam = "table_id";
      const params = new URLSearchParams(props?.location?.search);
      const tableId = params.get(tableIdParam);

      if (!tableId) {
        dispatch(clearTable());
        dispatch(setFlavour("ONLINE_ORDER"));
      } else {
        dispatch(setFlavour("TABLE_ORDER"));

        dispatch(setTableId(tableId));
        dispatch(getTableDetails(tableId));
        setFormValues({ orderType: ORDER_TYPES.TABLE_BOOKING_AND_ORDERING });
      }
    } catch (error) {
      // Handle the error if needed
    }
  }, [props?.location?.search, dispatch]);

  useEffect(() => {
    const checkTodayIsHoliday = () => {
      let isHoliday = false;
      let todayHolidayLabel = null;

      if (hotel?.shop_hoilidays && hotel?.shop_hoilidays?.length > 0) {
        const todayHoliday = hotel.shop_hoilidays.find(
          (h) => moment().format("YYYY-MM-DD") === h.date.toString()
        );

        if (todayHoliday) {
          isHoliday = true;
          todayHolidayLabel = todayHoliday.label;
        }
      }

      dispatch(setIsTodayHoliday(isHoliday, todayHolidayLabel));
    };

    checkTodayIsHoliday();
  }, [hotel, dispatch]);

  useEffect(() => {
    //google analytics
    const gac = hotel?.google_analytics_code;
    if (!gac || gac !== "null") {
      ReactGA.initialize(gac);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
    //facebook pixels
    const fpc = hotel?.facebook_pixels_code;
    if (!fpc || fpc !== "null") {
      // const advancedMatching = { em: "some@email.com" }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
      const options = {
        autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
        debug: false, // enable logs
      };
      // ReactPixel.init(fpc, advancedMatching, options);
      ReactPixel.init(fpc, options);
      ReactPixel.pageView(); // For tracking page view
    }
  }, [hotel]);

  // useEffect(() => {
  //   if (hotel?.is_alert === 1) {
  //     // Open the modal
  //     setSpecialModal(true); // Set to false to prevent it from reopening
  //   }
  // }, [hotel]);

  function hasModalBeenShown() {
    return localStorage.getItem("modalShown") === "true";
  }

  function holidayModalHasBeenShown() {
    return localStorage.getItem("holidayModalShown") === "true";
  }

  useEffect(() => {
    if (hotel?.is_alert === 1 && !hasModalBeenShown()) {
      if (hotel?.alert_image != null || hotel?.alert_text != null) {
        setSpecialModal(true);
        localStorage.setItem("modalShown", "true");
      }
    }

    const handleUnload = () => {
      localStorage.removeItem("modalShown");
    };

    window.addEventListener("pagehide", handleUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("pagehide", handleUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [hotel]);

  useEffect(() => {
    if (isTodayHoliday) {
      setHolidayModal(true);
    }
  }, [isTodayHoliday]);

  // useEffect(() => {
  //   if (state.selectedCategory === null) {
  //     parentDomRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [state.selectedCategory]);

  // scroll to active category
  useEffect(() => {
    if (state.selectedCategory) {
      const targetElement = sectionsRefs.current[state.selectedCategory];
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [state.selectedCategory]);

  const onProductclick = useCallback(
    (productDetails, addOns, category) => {
      toggleModal({
        type: "product",
        show: true,
      });
      selectProduct({
        info: productDetails,
        addons: addOns,
        categoryId: category.categoryId,
        menuVersion: category?.menu_version,
      });
    },
    [toggleModal, selectProduct]
  );

  const onComboclick = (comboDetails, combo) => {
    toggleModal({
      type: "combo",
      show: true,
    });
    selectCombo({
      info: comboDetails,
    });
    setProductCopy(cloneDeep(comboDetails));
  };

  const setMenuCategory = (categoryId) => {
    dispatch(getMenuCategoryList(categoryId));
    dispatch(toggleCategoryHomeMenu(false));
  };

  const handleCartClearModalClose = () => {
    dispatch(clearCart());
    setCartClearModal(false);
  };

  const handleBirthDayClose = () => {
    setBirthdayModal(false);
  };

  const handleHolidayModal = () => {
    setHolidayModal(false);
  };

  const Loader = () => (
    <React.Fragment>
      <Fade in={true}>
        <CategoryItemLoader />
      </Fade>
      <Fade in={true}>
        <CategoryItemLoader />
      </Fade>
      <Fade in={true}>
        <CategoryItemLoader />
      </Fade>
    </React.Fragment>
  );

  // const Loader = () => {
  //   <div className={classes.loader}>Loading...</div>;
  // };

  const getComboCatId = (combos) => {
    return combos?.[0]?.combo_cat_id;
  };

  const deliveryTime = useMemo(
    () =>
      checkoutDetails?.deliveryType === "ASAP"
        ? currentTime.toDate()
        : formatDateToCheck(checkoutDetails?.deliveryTime),
    [
      checkoutDetails?.deliveryType,
      checkoutDetails?.deliveryTime,
      currentTime,
      formatDateToCheck,
    ]
  );

  const [loading, setLoading] = useState(true);
  const [fullRender, setFullRender] = useState(false);

  const filteredCategories = useMemo(() => {
    const availableCategories = [];
    const unavailableCategories = [];

    sortedCategoryMenu?.forEach((category) => {
      // Check availability of the category itself
      const isCategoryAvailable = checkProductAvailability(
        category,
        checkoutDetails?.deliveryType === "ASAP"
          ? currentTime.toDate()
          : formatDateToCheck(checkoutDetails?.deliveryTime)
      );

      // Separate active and inactive items
      const activeItems = [];
      const inactiveItems = [];

      category?.item?.forEach((item) => {
        if (checkProductAvailability(item, deliveryTime)) {
          activeItems.push(item);
        } else {
          inactiveItems.push(item);
        }
      });

      // Merge active items first, followed by inactive items
      const updatedItems = [...activeItems, ...inactiveItems];

      const updatedCategory = {
        ...category,
        item: updatedItems, // Replace items with reordered list
      };

      if (activeItems.length > 0) {
        if (isCategoryAvailable) {
          availableCategories.push(updatedCategory);
        } else {
          unavailableCategories.push(updatedCategory);
        }
      } else if (!isCategoryAvailable) {
        // Add the category to unavailable list if no items are active
        unavailableCategories.push(updatedCategory);
      }
    });

    // Combine available categories first and then unavailable categories
    return [...availableCategories, ...unavailableCategories];
  }, [
    sortedCategoryMenu,
    deliveryTime,
    checkProductAvailability,
    checkoutDetails,
    currentTime,
    formatDateToCheck,
  ]);

  // const handleScroll = () => {
  //   const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

  //   if (scrollTop + clientHeight >= scrollHeight - 50) {
  //     setCurrentChunk((prev) => prev + 1);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  useEffect(() => {
    if (filteredCategories.length > 0) {
      // Show the loader initially and remove it after 5 seconds
      setTimeout(() => {
        setFullRender(true);
        setLoading(false);
      }, 5000);
    }
  }, [filteredCategories]);

  // const filteredCategories = useMemo(() => {
  //   return sortedCategoryMenu?.filter(
  //     (category) => category?.item && category.item.length > 0
  //   );
  // }, [sortedCategoryMenu]);

  // const [currentChunk, setCurrentChunk] = useState(1);
  // const chunkSize = 2;

  // const handleScroll = () => {
  //   const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
  //   if (scrollTop + clientHeight >= scrollHeight - 50) {
  //     setCurrentChunk((prev) => prev + 1);
  //   }
  // };

  // const handleAlertClose = () => {
  //   // console.log("wrkkkkkkkkkkkkk");
  //   setAlertOpen(false);
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // const visibleItems = filteredCategories?.slice(0, chunkSize * currentChunk);

  return (
    <div ref={parentDomRef} className={classes.roottt}>
      {/* <Navbar mainHeader={true} /> */}
      {!isHotelFetchCompleted ? (
        <BasicLoader />
      ) : (
        <Suspense fallback={<Loader />}>
          {showLandingPage && (
            <div>
              <Typography
                className={`mt-4 mb-4 ${classes.title}`}
                variant="h2"
                noWrap
              >
                Main Menu
              </Typography>
              <Grid container spacing={2}>
                {state?.comboCategories?.map((c) => (
                  <Grid
                    item
                    key={c.combo_id}
                    xs={6}
                    sm={3}
                    onClick={() => setMenuCategory(c.combo_id)}
                  >
                    <div className={classes.catCont}>
                      <CardMedia
                        className={clsx(classes.img, c.image || "no-image")}
                        component="img"
                        src={c.image || noImage.default}
                        {...props}
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = noImage.default;
                          e.target.className = `${e.target.className} no-image`;
                        }}
                      />
                      <div className={classes.categoryName}>
                        <Typography className={classes.label} variant="caption">
                          {c.category_name}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ))}
                {state.category.map((c, i) => (
                  <Grid
                    item
                    key={c.categoryId}
                    xs={6}
                    sm={3}
                    onClick={() => setMenuCategory(c.categoryId)}
                  >
                    <CardMedia
                      className={clsx(classes.img, c.imageURL || "no-image")}
                      component="img"
                      loading="lazy"
                      src={c.imageURL || noImage.default}
                      {...props}
                      onError={(e) => {
                        e.target.src = noImage.default;
                        e.target.className = `${e.target.className} no-image`;
                      }}
                    />
                    <div className={classes.categoryName}>
                      <Typography className={classes.label} variant="caption">
                        {c.label}
                      </Typography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
          {!showLandingPage && (
            <div>
              {/* <Typography
                className={`mt-4 mb-4 ${classes.title}`}
                variant="h2"
                noWrap
              >
                Main Menu
              </Typography> */}
              {sortedComboMenu &&
                Object.keys(sortedComboMenu).length > 0 &&
                Object.keys(sortedComboMenu)?.map((c, index) => {
                  // Filter out inactive combos
                  const activeCombos = sortedComboMenu[c]?.filter(
                    (combo) =>
                      checkProductAvailability(
                        combo,
                        checkoutDetails?.deliveryType === "ASAP"
                          ? currentTime.toDate()
                          : formatDateToCheck(checkoutDetails?.deliveryTime)
                      ) &&
                      checkComboCatAvailability(
                        combo,
                        checkoutDetails?.deliveryType === "ASAP"
                          ? currentTime.toDate()
                          : formatDateToCheck(checkoutDetails?.deliveryTime)
                      )
                  );

                  // Only render categories that have active combos
                  if (activeCombos.length > 0) {
                    return (
                      <div
                        key={getComboCatId(sortedComboMenu[c])}
                        ref={(el) =>
                          (sectionsRefs.current[
                            Object.keys(sortedComboMenu[c]).length + index
                          ] = el)
                        }
                        data-id={getComboCatId(sortedComboMenu[c])}
                      >
                        <ComboItem
                          key={c}
                          combos={activeCombos}
                          comboCategory={c}
                          onComboclick={onComboclick}
                        />
                      </div>
                    );
                  }

                  return null; // Don't render anything if no active combos
                })}
              {/* {filteredCategories?.map((category) => {
                return (
                  <div
                    key={category?.categoryId}
                    ref={(el) =>
                      (sectionsRefs.current[category.categoryId] = el)
                    }
                    data-id={category?.categoryId}
                  >
                    <CategoryItem
                      id={category?.categoryId}
                      data-name={category?.label}
                      category={category}
                      className="category-item"
                      onProductclick={onProductclick}
                    />
                  </div>
                );
              })} */}
              {filteredCategories?.map((category) => (
                <div
                  key={category?.categoryId}
                  ref={(el) => (sectionsRefs.current[category.categoryId] = el)}
                  data-id={category?.categoryId}
                >
                  <CategoryItem
                    id={category?.categoryId}
                    data-name={category?.label}
                    category={category}
                    className="category-item"
                    onProductclick={onProductclick}
                  />
                </div>
              ))}
              {/* {loading ? (
                <Loader /> // Replace with a spinner or Skeleton loader
              ) : (
                filteredCategories?.map((category) => (
                  <div
                    key={category?.categoryId}
                    ref={(el) =>
                      (sectionsRefs.current[category.categoryId] = el)
                    }
                    data-id={category?.categoryId}
                  >
                    <CategoryItem
                      id={category?.categoryId}
                      data-name={category?.label}
                      category={category}
                      className="category-item"
                      onProductclick={onProductclick}
                    />
                  </div>
                ))
              )} */}
              {/* <InfiniteScrollComponent
                items={visibleItems}
                onProductclick={onProductclick}
                isBottom={isBottom}
              /> */}
              {/* {filteredCategories?.map((category, index) => ( */}
              {/* {sortedCategoryMenu?.map((category, index) => (
                <div
                  key={category?.categoryId}
                  ref={(el) => (sectionsRefs.current[index] = el)}
                  data-id={category?.categoryId}
                >
                  <CategoryItem
                    id={category?.categoryId}
                    data-name={category?.label}
                    category={category} // Pass filtered category with active items
                    className="category-item"
                    onProductclick={onProductclick}
                  />
                </div>
              ))} */}
            </div>
          )}
        </Suspense>
      )}
      <Modal
        customView={true}
        open={modal.show}
        handleClose={() => toggleModal(modalInit)}
      >
        {modal.type === "product" && (
          <ViewProduct
            product={product.info}
            addons={product.addons}
            categoryId={product.categoryId}
            menuVersion={product?.menuVersion}
            handleClose={() => toggleModal(modalInit)}
          />
        )}
        {modal.type === "combo" && (
          <ViewCombo
            product={productCopy}
            handleClose={() => toggleModal(modalInit)}
          />
        )}
        {/* {birthdayModal && <BirthdayCard />} */}
      </Modal>
      {showPopper && <BirthdayCard open={showPopper} user={userData} />}
      <SpecialAlert
        open={specialModal}
        handleClose={() => setSpecialModal(false)}
        title={hotel?.alert_text}
        image={hotel?.alert_image}
        isBtnRight={true}
      />
      <SpecialAlert
        open={cartClearModal}
        title="We apologize for any inconvenience. Due to a price change, we are also clearing the items from your cart."
        handleClose={handleCartClearModalClose}
        isCartClear={true}
      />
      <SpecialAlert
        open={birthdayModal}
        title={`Happy Birthday ${userData?.name}`}
        handleClose={handleBirthDayClose}
        // isCartClear={true}
      />
      {isTodayHoliday && (
        <HolidayModal
          open={holidayModal}
          title={todayHolidayLabel}
          handleClose={handleHolidayModal}
        />
      )}
      <Dialog
        maxWidth="sm"
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <LoginDialogCon setOpen={setLoginOpen} />
        {/* <SocialMediaLogin /> */}
      </Dialog>
      {/* <SplAlert
        open={alertOpen}
        setClose={handleAlertClose}
        message={`You have arrived outside of our regular opening hours. However, you have the option to pre-order for a later time ${nextAvailableTime}..`}
      /> */}
    </div>
  );
};

export default Home;
